<script>
import Main from './main.vue';

export default Main.extend({
  methods: {
    getData() {
      return new Promise((res) => {
        // Seed data
        const output = [
          {
            name: 'Automotive',
            data: [{
              x: 0,
              y: 76,
              qa: {
                score: 76,
                level: 75,
              },
              reports: 12,
            }],
          },
          {
            name: 'Aviation',
            data: [{
              x: 1,
              y: 73,
              qa: {
                score: 73,
                level: 73,
              },
              reports: 5,
            }],
          },
          {
            name: 'Consulting',
            data: [{
              x: 2,
              y: 55,
              qa: {
                score: 55,
                level: 60,
              },
              reports: 20,
            }],
          },
        ];
        res(output);
      });
    },
  },
});
</script>
